import { render, staticRenderFns } from "./CallcentreQueue.vue?vue&type=template&id=01432513&"
import script from "./CallcentreQueue.vue?vue&type=script&lang=js&"
export * from "./CallcentreQueue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports